export default {
  verifyScroll(region = true) {
    const id = region ? "doseSection" : "doseSectionUnit";
    const scrollDiv = document.getElementById(id);

    if (!scrollDiv?.classList) return;

    const scrolledPast = window.pageYOffset >= scrollDiv.offsetHeight;
    if (window.innerWidth >= 748 && scrolledPast) {
      scrollDiv.classList.add("scrollAnimate");
    } else {
      scrollDiv.classList.remove("scrollAnimate");
    }
  },
};
